/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

import StringFormatHelper from '../../helpers/StringFormatHelper';
import DateInputMaskHelper from '../../helpers/DateInputMaskHelper';

export default class FormInput extends Component {
    constructor(props) {
        super(props);
        const state = {} || this.state;
        state.value = this.props.value;
        this.state = state;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.invalidSubmit) {
            return true;
        }

        if (this.state.value !== nextState.value) {
            return true;
        }

        if (this.state.value !== nextProps.value &&
            this.props.value !== nextProps.value) {
            this.state.value = nextProps.value;
            return true;
        }
        return false;
    }

    onChange(event) {
        if (this.props.setValue) {
            this.props.setValue(event.target.value);
        }

        const state = this.state;

        /* eslint indent: 0 */
        switch (this.props.maskType) {
            case 'currency':
                if (!isNaN(parseInt(event.target.value))) {
                    state.value = StringFormatHelper.formatToCurrency(parseInt(event.target.value));
                } else if (!event.target.value || event.target.value === '£') {
                    state.value = '';
                } else {
                    const tempValue = StringFormatHelper.formatToNumber(event.target.value);
                    state.value = StringFormatHelper.formatToCurrency(tempValue);
                }
                break;
            case 'dateOfBirth':
                state.value = DateInputMaskHelper.applyMaskDate(state.value, event.target.value);
                break;
            default:
                state.value = event.target.value;
        }

        this.setState(state);
        this.forceUpdate();
    }

    onBlur(event) {
        if (!this.lostFocusAtLeastOnce) {
            this.lostFocusAtLeastOnce = true;
        }

        if (this.props.setValue) {
            this.props.setValue(event.target.value);
        }

        if (this.props.handleChange && event.target.value !== this.oldValue) {
            this.props.handleChange(event);
            this.oldValue = event.target.value;
        }

        this.forceUpdate();
    }

    onKeyPress(event) {
        if (event.key === 'Enter') {
            this.onBlur(event);
        }
    }

    getInputProperties(className) {
        const widthProportion = this.props.widthProportion ? this.props.widthProportion : 'full';
        const requiredClass = this.showRequired() ? `${className}--required` : '';
        const readOnlyClass = this.props.readOnly ? `${className}--read-only` : '';

        let style = {};
        if (this.props.fixedWidth) {
            style = {
                width: this.props.fixedWidth,
            };
        }

        const inputProperties = {
            className: `${className}__input ${widthProportion} ${requiredClass} ${readOnlyClass}`,
            onChange: this.onChange.bind(this),
            onBlur: this.onBlur.bind(this),
            onKeyPress: this.onKeyPress.bind(this),
            placeholder: this.props.placeholder,
            type: this.props.type,
            name: this.props.name,
            value: this.state.value,
            readOnly: this.props.readOnly,
            maxLength: this.props.maxLength,
            style,
        };

        if (this.props.maskType === 'phoneNumber') {
            inputProperties.mask = '99999 999 999';
            inputProperties.maskChar = '';
        }

        if (this.props.maskType === 'number') {
            inputProperties.mask = '99999999999';
            inputProperties.maskChar = '';
        }

        return inputProperties;
    }

    renderHint() {
        if (!this.props.hintText) {
            return null;
        }

        return <span className="app__hint">
            { this.props.hintText }
        </span>;
    }

    renderLabel(className) {
        if (!this.props.label) {
            return '';
        }

        if (this.props.labelMobileOnly) {
            return (
                <div className={ `${className}__label--mobile` }>
                    { this.props.label }
                </div>
            );
        }

        return (
            <div className={ `${className}__label` }>
                { this.props.label }
            </div>
        );
    }

    renderErrorMessage(className) {
        if (!this.props.getErrorMessage || !this.props.getErrorMessage()) {
            return '';
        }

        return <span className={ `${className}__error-message` }>{ this.props.getErrorMessage() }</span>;
    }

    showRequired() {
        if (!this.props.showRequired || !this.props.showRequired()) {
            return false;
        }

        if (this.props.showRequired() && this.lostFocusAtLeastOnce) {
            return true;
        }

        if (this.props.showRequired() && this.props.invalidSubmit) {
            return true;
        }

        return false;
    }
}

FormInput.propTypes = {
    /* input value and label defaults */
    name: React.PropTypes.string,

    label: React.PropTypes.string,
    labelMobileOnly: React.PropTypes.bool,
    placeholder: React.PropTypes.string,
    hintText: React.PropTypes.string,

    value: React.PropTypes.node,
    type: React.PropTypes.string,
    readOnly: React.PropTypes.bool,

    /* style and masks */
    maskType: React.PropTypes.string,
    className: React.PropTypes.string,
    widthProportion: React.PropTypes.string,
    fixedWidth: React.PropTypes.string,

    /* callbacks */
    handleChange: React.PropTypes.func,

    invalidSubmit: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/elements/FormInput.jsx